import ReactDOM from "react-dom/client";
import { store, persistor } from "./store/store";
import { App as AppAntd } from "antd";
import App from "./App";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

const rootElement = document.getElementById("root");
const root = ReactDOM.createRoot(rootElement);
// const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  //<StrictMode>
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AppAntd>
        <App />
      </AppAntd>
    </PersistGate>
  </Provider>
  //</StrictMode>
);
